import "core-js/modules/es.array.push.js";
import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.map.js";
import plan from './plan.vue';
import { auditTypeStore, auditTypeDetail, auditTypeEdit, auditScheduleResource } from './request';
export default {
  components: {
    plan
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
      required: true
    },
    isEdit: {
      type: Boolean | Number | String,
      default: false,
      required: true
    }
  },
  data() {
    return {
      addForm: {
        name: ''
      },
      planList: []
    };
  },
  computed: {
    ADD_RULES() {
      return {
        name: [{
          required: true,
          message: this.$t('请输入') + this.$t('类型名称'),
          trigger: 'blur'
        }, {
          message: '1-50' + this.$t('字符'),
          max: 50,
          min: 1
        }]
      };
    }
  },
  watch: {
    visible(newV) {
      this.planList = [];
      if (newV && this.$props.isEdit) {
        this.getDetail();
      }
    }
  },
  methods: {
    closeAddVisible(e) {
      this.$emit('cancel', e);
      this.resetForm();
      this.emptyForm();
    },
    async getDetail(index) {
      if (this.$props.isEdit) {
        const res = await auditTypeDetail({
          auditFlowTypeId: this.$props.isEdit
        });
        Object.assign(this.addForm, res);
        const resource = await auditScheduleResource({
          auditFlowTypeId: this.$props.isEdit
        });
        this.planList.splice(0, this.planList.length);
        this.planList.push(...resource);
      } else {
        this.planList.splice(index, 1);
      }
    },
    saveAdd() {
      this.$refs.addFormRef.validate(async valid => {
        if (valid) {
          if (this.planList.length === 0 || this.planList.length > 1) {
            let ids = [];
            if (this.planList.length) {
              this.planList.map(item => {
                ids.push(item.id);
              });
            }
            if (this.$props.isEdit) {
              await auditTypeEdit({
                name: this.addForm.name,
                auditFlowTypeId: this.addForm.id,
                auditScheduleId: ids.join(',')
              });
            } else {
              await auditTypeStore({
                name: this.addForm.name,
                auditScheduleId: ids.join(',')
              });
            }
            this.$emit('save');
            this.closeAddVisible();
            this.$message.success(this.$t('保存成功'));
          } else {
            this.$message.warning(this.$t('请至少添加2个进度'));
          }
        }
      });
    },
    updateList(isEdit, data) {
      if (isEdit.length) {
        this.planList.map(item => {
          if (item.id === data.id) {
            item.name = data.name;
            item.iconName = data.iconName;
          }
        });
      } else {
        this.planList.push(data);
      }
    },
    resetForm() {
      this.$refs.addFormRef.resetFields();
    },
    emptyForm() {
      this.addForm.name = '';
    }
  }
};